var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { defineComponent as _defineComponent } from 'vue';
import { FontAwesomeIcon } from "@fortawesome/vue-fontawesome";
import { BAlert, BTab, BTabs } from "bootstrap-vue";
import Vue, { computed, ref, watch } from "vue";
import { GalaxyApi } from "@/api";
import {} from "@/api/jobs";
import { getHeaderClass, iconClasses } from "@/composables/useInvocationGraph";
import { rethrowSimple } from "@/utils/simple-error";
import JobDetailsDisplayed from "../JobInformation/JobDetails.vue";
import LoadingSpan from "../LoadingSpan.vue";
export default /*#__PURE__*/ _defineComponent({
    __name: 'JobStep',
    props: {
        jobs: { default: () => [] }
    },
    setup(__props) {
        const props = __props;
        const loading = ref(true);
        const initialLoading = ref(true);
        const jobsDetails = ref({});
        watch(() => props.jobs, (propJobs) => __awaiter(this, void 0, void 0, function* () {
            loading.value = true;
            for (const job of propJobs) {
                const { data, error } = yield GalaxyApi().GET("/api/jobs/{job_id}", {
                    params: {
                        path: { job_id: job.id },
                        query: { full: true },
                    },
                });
                Vue.set(jobsDetails.value, job.id, data);
                if (error) {
                    rethrowSimple(error);
                }
            }
            if (initialLoading.value) {
                initialLoading.value = false;
            }
            loading.value = false;
        }), { immediate: true });
        const firstJob = computed(() => Object.values(jobsDetails.value)[0]);
        const jobCount = computed(() => Object.keys(jobsDetails.value).length);
        function getIcon(job) {
            return iconClasses[job.state];
        }
        function getTabClass(job) {
            return Object.assign(Object.assign({}, getHeaderClass(job.state)), { "d-flex": true, "text-center": true });
        }
        return { __sfc: true, props, loading, initialLoading, jobsDetails, firstJob, jobCount, getIcon, getTabClass, FontAwesomeIcon, BAlert, BTab, BTabs, JobDetailsDisplayed, LoadingSpan };
    }
});
